"use client";
import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import BasicPopover from "./BasicPopover";
import { ExperienceObj } from "@/app/@types/experienceobj";

/**
 * A React component used to display a single YEX experience.
 *
 * @remarks
 * This component displays a single YEX experience in the panel of three YEX
 * experience options.  It is a child to the RecPanelInner component that holds
 * three Experience components.  It is also a parent to the BasicPopover component
 * used to display the experience indended results.
 * @param {id, category, name, results, use, productWarings, productUsageAdvisory, image, estTime } : ExperienceObj
 * @returns
 */
export default function Experience({
  id,
  category,
  name,
  results,
  use,
  productWarnings,
  productUsageAdvisory,
  image,
  estTime,
}: ExperienceObj) {
  return (
    <Box>
      <Card
        style={{
          padding: "10px",
          marginBottom: "30px",
          backgroundColor: "secondary.dark",
          color: "secondary.light",
        }}
      >
        <Typography sx={{ bgcolor: "secondary.dark" }} align="center">
          <CardHeader
            sx={{
              display: "inline",
              alignItems: "center",
              color: "secondary.light",
            }}
            action={
              <FormControlLabel
                value={name + ":" + id}
                control={<Radio sx={{ color: "secondary.light" }} />}
                sx={{ color: "secondary.light" }}
                label={
                  <Typography
                    sx={{
                      fontSize: 24,
                      bgcolor: "secondary.dark",
                      color: "secondary.light",
                    }}
                  >
                    {name}
                  </Typography>
                }
              />
            }
          />
        </Typography>
        <CardMedia
          component="img"
          sx={{
            height: 540,
            objectFit: "contain",
            backgroundColor: "secondary.dark",
          }}
          image={"/" + image}
          title={name}
        />
        <CardContent
          sx={{
            color: "secondary.light",
            bgcolor: "secondary.dark",
            overflow: "visible",
            height: "200px",
          }}
        >
          <Typography
            variant="body1"
            component="div"
            style={{
              height: "125px",
              backgroundColor: "secondary.dark",
              color: "secondary.light",
              marginBottom: "20px",
            }}
          >
            {use}
          </Typography>
          <Typography
            variant="body1"
            component="div"
            style={{
              backgroundColor: "secondary.dark",
              color: "secondary.light",
              textAlign: "center", // Centers text horizontally
            }}
          >
            {"Est time: " + estTime}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            alignItems: "center",
            justifyContent: "center",
            color: "secondary.light",
            backgroundColor: "secondary.dark",
          }}
        >
          <BasicPopover
            results={results}
            productUsageAdvisory={productUsageAdvisory}
            productWarnings={productWarnings}
          />
        </CardActions>
      </Card>
    </Box>
  );
}
